import DropdownControl from "../dropdown/DropdownControl";
import ListSelector from "./ListSelector";
import {User} from "../user-selector/User";
import {h} from "preact";
import ButtonControl from "../button-control";
import UserList from "./UserList";

type Props = {
    header: (close: () => void) => JSX.Element,
    buttonTitle: string | JSX.Element,
    icon?: string,
    onUserClick: (user: User) => Promise<any>,
    newStyle?: boolean,
    align?: 'left' | 'right'
}

const DynamicModeratorList = ({header, buttonTitle, icon, onUserClick, newStyle = false, align}: Props) =>
    <div class={newStyle ? 'dynamic-moderator-list' : ''}>
        <DropdownControl
            align='adjust'
            showDefaultChildren
            triggerClass={icon && 'dropdown-wrapper'}
            trigger={
                <ButtonControl
                    icon={icon}
                    title={buttonTitle}
                    newStyle={newStyle && newStyle}
                    size={newStyle ? 'medium' : ''}
                    class='qa-topic-moderation-assign-moderator'
                />
            }
            items={[]}>
            {({close}: { close: () => void }) =>

                <ListSelector
                    align={align}
                    isDynamic
                    header={header(close)}
                    hasSearch
                    fetchUrl='/member/getModerators?query='
                    placeholder='Search for moderator'>
                    {(users: User[]) => <div>
                        <UserList users={users} onClick={(user: User) => onUserClick(user).then(() => close())}/>
                    </div>}
                </ListSelector>}
        </DropdownControl>
    </div>
export default DynamicModeratorList

